import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'
import ParentActivationPersonalDataModule from '../personalData'

const ActivationPersonalDataModule = {
  namespaced: true,
  state: {
    person: null,
    address: null,
    additional: null,
    identInformation: null
  },
  getters: {
    personal: ParentActivationPersonalDataModule.getters.personal,
    firstName: ParentActivationPersonalDataModule.getters.firstName,
    lastName: ParentActivationPersonalDataModule.getters.lastName,
    gender: state => state.person?.gender,
    birthDate: state => state.person?.birthDate,
    email: ParentActivationPersonalDataModule.getters.email,
    address: state => {
      return {
        city: state.address?.city,
        zip: state.address?.zip,
        street: state.address?.street,
        houseNumber: state.address?.houseNumber,
        supplement: state.address?.supplement
      }
    },
    additional: ParentActivationPersonalDataModule.getters.additional,
    identificationFull: ParentActivationPersonalDataModule.getters.identificationFull,
    identificationCore: ParentActivationPersonalDataModule.getters.identificationCore,
    validateAddressCore: ParentActivationPersonalDataModule.getters.validateAddressCore,
    tariffIdentifier: ParentActivationPersonalDataModule.getters.tariffIdentifier,
    customerCore: (state, getters) => {
      return {
        gender: getters.gender,
        firstName: getters.firstName,
        lastName: getters.lastName,
        birthDate: getters.birthDate,
        email: getters.email,
        address: getters.address
      }
    }
  },
  actions: {
    async validate ({ dispatch, commit, state, getters, rootGetters }, { person, address, identInformation, additional, nextStep }) {
      commit('clearMessages', {}, { root: true })
      commit('storePersonalData', person)
      commit('storeIdent', identInformation)
      commit('storeAdditional', additional)
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation activation ($validateAddressInput: ValidateAddressInput!) {
          validateAddress (validateAddressInput: $validateAddressInput){
            address {
              street,
              houseNumber,
              zip,
              city,
              supplement
            }
          }
        }`,
        variables: {
          validateAddressInput: {
            ...getters.validateAddressCore,
            address: address
          }
        }
      }).then((response) => {
        if (response.data.validateAddress.address) {
          // das supplement wird nicht von magam zurückgegeben bei der validierung, taucht aber später wieder auf
          commit('storeAddress', Object.assign({ supplement: address.supplement }, response.data.validateAddress.address))
          // if next step is summary, we need to perform the initilize here
          if (nextStep === 'summary') {
            return dispatch('activation/submit/activationInitiate', { nextStep: nextStep }, { root: true })
          } else {
            commit('activation/goToStep', nextStep, { root: true })
          }
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    storePersonalData: ParentActivationPersonalDataModule.mutations.storePersonalData,
    storeAddress: ParentActivationPersonalDataModule.mutations.storeAddress,
    storeIdent: ParentActivationPersonalDataModule.mutations.storeIdent,
    storeAdditional: ParentActivationPersonalDataModule.mutations.storeAdditional
  }
}

export default ActivationPersonalDataModule
